import { Tabs, TabPanels, TabPanel, TabList, Tab } from "@chakra-ui/tabs";
import { MdAlarm, MdOfflineBolt } from "react-icons/md";
import { t } from "i18next";
import { TableHeightLayout } from "hooks/viewport-dimensions";
import ScheduleReports from "./schedule/page";
import AdhocReports from "./adhoc/page";
import { CONST } from "models/constants";
import { usePermissions } from "hooks/usePermissions";
import { useCallback, useState } from "react";
import { useNotificationDialog } from "providers/notification-dialog-provider";

const Reports = () => {
  const { canShow } = usePermissions();
  const { notify } = useNotificationDialog();
  const [tabIndex, setTabIndex] = useState(0);
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const handleTabChange = useCallback(
    (nextIndex: number) => {
      if (hasUnsavedChanges && nextIndex !== tabIndex) {
        notify({
          header: t("dialog.unsaved.changes.header"),
          message: t("dialog.unsaved.changes.message"),
          okText: t("dialog.unsaved.changes.discard"),
          cancelText: t("dialog.unsaved.changes.back"),
          onOk: () => {
            setHasUnsavedChanges(false);
            setTabIndex(nextIndex);
          },
          onCancel: () => {},
        });
      } else {
        setTabIndex(nextIndex);
      }
    },
    [hasUnsavedChanges, tabIndex]
  );

  return (
    <TableHeightLayout>
      <Tabs index={tabIndex} onChange={handleTabChange} variant="plain" isLazy>
        <TabList className="rounded-lg bg-gray-300 p-2">
          <Tab className="min-w-36 gap-1 rounded-lg p-1 text-primary aria-selected:bg-background-50 aria-selected:text-white">
            <MdOfflineBolt />
            {t("reports.tabs.adhoc")}
          </Tab>
          {canShow(CONST.ROLE_SUPER) && (
            <Tab className="min-w-36 gap-1 rounded-lg p-1 text-primary aria-selected:bg-background-50 aria-selected:text-white">
              <MdAlarm />
              {t("reports.tabs.schedule")}
            </Tab>
          )}
        </TabList>
        <TabPanels>
          <TabPanel>
            <AdhocReports />
          </TabPanel>
          {canShow(CONST.ROLE_SUPER) && (
            <TabPanel>
              <ScheduleReports setHasUnsavedChanges={setHasUnsavedChanges} />
            </TabPanel>
          )}
        </TabPanels>
      </Tabs>
    </TableHeightLayout>
  );
};

export default Reports;
